module.exports = __webpack_public_path__ + "static/media/img7.05b79808.jpg";